import { render } from "./StoreView.vue?vue&type=template&id=3e8a470e&ts=true"
import script from "./StoreView.vue?vue&type=script&lang=ts"
export * from "./StoreView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__